<template>

  <m-card520 :image="content.thumbnail" :alt="content.title">



    <template #p-1>

       {{ contentSlicer(content.title, 40) }}

    </template>

    <template #p-2>

      <p v-html="contentSlicer(content.body,100)"></p>

    </template>

    <template #p-3>

      <span  v-t="`content.card.more`"></span>

    </template>




  </m-card520>


</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard520 from "../../Cards/Card520";
import mA from '../../Tags/A'
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";


export default {
  name: "ContentCard504",
  methods: {contentSlicer},
  components: { mCard520, mA},
  props: {
    content: {},
    buttonText:{
      default:"اطلاعات بیشتر"
    }
  },
  computed: {
    ...CardComputed
  },
  mounted() {

  }

}
</script>

<style scoped>
.description-card{
  font-size: 0.875em;

}

.title-card{
  font-size: 19px;

}

.show-button-content-501{
  font-size: 15px;

}

.icon-show-content{
  font-size: 0.875em;

}

</style>